import { WitaConnector } from '@/services/repository/connector'
import { querySerializer } from '@/utils/helpers/URLs'

import { Repo } from './AssetLink.d'

const ROOT_URL = '/entity/asset-links'

export const AssetLinkRepository = {
  Search: async (params: Repo.AssetLink.Search.Params) => {
    const url = ROOT_URL + `?${querySerializer(params)}`
    return await WitaConnector.get<Repo.AssetLink.Search.Response>(url)
  },

  Create: async (params: Repo.AssetLink.Create.Params) => {
    const url = ROOT_URL
    return await WitaConnector.post<Repo.AssetLink.Create.Response>(url, params)
  },

  Edit: async ({ id, ...params }: Repo.AssetLink.Edit.Params) => {
    const url = ROOT_URL + `/${id}`
    return await WitaConnector.put<Repo.AssetLink.Edit.Response>(url, params)
  },
}
